import React from "react";
import { Dialog, useMediaQuery } from "@mui/material";
import useTranslation from "../hooks/useTranslation";

interface FullScreenImageDialogProps {
  open: boolean;
  onClose: () => void;
  image?: string;
}

const FullScreenImageDialog = ({ open, onClose, image }: FullScreenImageDialogProps) => {
  const fullScreen = useMediaQuery('(max-width: 639px)');
  const { translate } = useTranslation("common");
  
  return (
    <>
      {image && (
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClick={onClose}
          sx={{ "&.MuiDialog-root .MuiPaper-root": { background: fullScreen ? "black" : "" } }}
        >
          {<img src={image} alt={translate("image")} className="w-full cover" />}
        </Dialog>
      )}
    </>
  );
};

export default FullScreenImageDialog;